import { render, staticRenderFns } from "./ProductImage.vue?vue&type=template&id=e0394d92&scoped=true"
import script from "./ProductImage.vue?vue&type=script&lang=js"
export * from "./ProductImage.vue?vue&type=script&lang=js"
import style0 from "./ProductImage.vue?vue&type=style&index=0&id=e0394d92&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0394d92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2794229096/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0394d92')) {
      api.createRecord('e0394d92', component.options)
    } else {
      api.reload('e0394d92', component.options)
    }
    module.hot.accept("./ProductImage.vue?vue&type=template&id=e0394d92&scoped=true", function () {
      api.rerender('e0394d92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductImage.vue"
export default component.exports